<template>
    <transition name="fade" mode="out-in">
        <router-view  v-if="!this.$browserDetect.isOpera"></router-view>
        <div v-if="this.$browserDetect.isOpera" class="download-browser">
            <h1>{{$t('COMMON.browserText')}}</h1>
            <a href="https://www.google.com/intl/pl_pl/chrome/" class="btn btn-primary">{{$t('COMMON.downloadChrome')}}</a>
        </div>
    </transition>
</template>

<script>

export default {
    name: 'app'
};
</script>

<style lang="scss">
    @import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
    @import "../node_modules/input-range-scss/inputrange";
    @import "./styles/fonts";
    @import "./styles/base";
    .header-search { 
        height: 40px;
    }
    .d-none {
        display: none;
    }
    .table td {
        padding: 0;
    }    
    .table th {
        padding: auto;
        .form-control {
            border: 0;
        }
    }
    .table td, .table th{
        vertical-align: middle;
        text-align: center;
    }
    .middle{
      vertical-align: middle;
      text-align: center;
    }
    .selecter{
      margin-bottom: 1rem;
      width: 100px;
      .form-control{
        border-radius: 0;
        line-height: 34px;
        height: 34px;
        padding: 0 .75rem;
      }
    }
    div.vuetable {
        //width: 80%;
        @media (max-width: 771px){
          overflow-x: scroll;
        }
        thead{
          tr:last-of-type{
            th{
              padding: 0.5rem;
            }
          }
        }
        th.sorted-asc, th.sorted-desc {
            i.arrow {
                margin-left: 10px;
                border: solid black;
                border-width: 0 3px 3px 0;
                display: inline-block;
                padding: 3px;
            }
            &.sorted-asc {
                i.arrow {
                    transform: rotate(-135deg);
                    -webkit-transform: rotate(-135deg);
                }
            }
            &.sorted-desc {
                i.arrow {
                    transform: rotate(45deg);
                    -webkit-transform: rotate(45deg);
                }
            }
        }
        td.vuetable-td-iconURL, td.vuetable-slot {
            vertical-align:middle;
            text-align:center;
        }
        div.vuetable-pagination {
            margin-top: 1rem;
            background: none !important;
        }
    }
    div.hidden {
        display: none;
    }
    .search-field{
      .form-control{
        font-size: 1em;
        border: 0;
      }
    }
    .unregistred td {
      background-color: #c7c7c7;
    }
    .registred td {
      background-color: #b2ffb2;
    }
    .download-browser {
        display: flex;
        justify-content: center;
        flex-direction: column;
        align-items: center;
        margin-top: 45vh
    }
</style>
